"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../../Button/Button");
var _InFormInput = _interopRequireDefault(require("./InFormInput"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Captcha = _interopRequireDefault(require("../Captcha/Captcha"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.inForm-container .hidden {\n  display: none; }\n\n.inForm-container .bx--label {\n  color: #4c4c4c; }\n\n.inForm-container .checkbox {\n  margin-bottom: 8px; }\n\n.inForm-container .inform-checkbox {\n  margin-bottom: 42px;\n  margin-top: 42px; }\n";
  const fileName = "InForm_InForm";
  const element = document.querySelector("style[data-sass-component='InForm_InForm']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const getConditionalRequired = (required, defaultValues) => {
  if (!required) return false;
  let res = false;
  const rules = Object.entries(required);
  rules.forEach(_ref => {
    let [rule, value] = _ref;
    const field = rule.split('=')?.length > 1 ? rule.split('=')[1]?.replaceAll('"', '')?.replaceAll(']', '') : '';
    const defaultValue = typeof defaultValues[field] === 'object' ? defaultValues[field].id : defaultValues[field];
    if (defaultValue === value.value) res = true;
  });
  return res;
};
const InForm = _ref2 => {
  let {
    lang,
    form_id,
    items,
    onSubmit,
    translate,
    defaultValues,
    captchaKey,
    fetchTerms,
    confirmationPage
  } = _ref2;
  const [values, setValues] = (0, _react.useState)(defaultValues || {});
  const [errors, setErrors] = (0, _react.useState)({});
  const [text, setText] = (0, _react.useState)('');
  const [error, setError] = (0, _react.useState)('');
  const [captchaError, setCaptchaError] = (0, _react.useState)('');
  const [captchaValue, setCaptchaValue] = (0, _react.useState)(null);
  const captchaRef = (0, _react.useRef)();
  const fields = Object.entries(items || {})?.map(_ref3 => {
    let [key, value] = _ref3;
    const isRequired = value['#required'] || getConditionalRequired(value['#states']?.required, defaultValues);
    return {
      id: key,
      label: value['#title'],
      type: value['#type'],
      options: value['#options'],
      required: isRequired,
      description: value['#description'],
      class: value['#wrapper_attributes']?.class,
      vocabulary: value['#vocabulary'],
      pattern: value['#pattern_error']
    };
  });
  const setValuesAux = newVal => {
    setValues(newVal);
    let errorsAux = errors;
    Object.entries(errors)?.forEach(error => {
      if (error[1] !== 'form.input.error.empty') return;
      const newErrorValue = getError(fields.find(field => field.id === error[0]), newVal);
      if (!newErrorValue) {
        errorsAux[error[0]] = undefined;
      }
    });
  };
  const getError = (field, values) => {
    let error = undefined;
    if (field.required && (values[field.id] === undefined || values[field.id] === '' || values[field.id] == [] || values[field.id] === false)) {
      error = 'form.input.error.empty';
    }
    return error;
  };
  const submit = () => {
    setText('');
    setError('');
    let errorsAux = {
      ...errors
    };
    fields.forEach(field => {
      errorsAux[field.id] = !errorsAux[field.id] || errorsAux[field.id] === 'form.input.error.empty' ? getError(field, values) : errorsAux[field.id];
    });
    if (Object.entries(errorsAux).filter(item => item[1] !== undefined).length === 0 && captchaValue) {
      const formatedValues = Object.fromEntries(Object.entries(values).map(value => {
        return [value[0], typeof value[1] === 'object' && value[1].id ? value[1].id : value[1]];
      }));
      onSubmit && onSubmit(lang, form_id, {
        ...formatedValues,
        captcha_response: captchaRef?.current?.getValue()
      }, data => {
        if (confirmationPage) {
          const to = `/${lang}/cms/node/${confirmationPage}`;
          window.location.replace(to);
        } else {
          setValues(defaultValues);
          setText(translate('cms.form.success'));
          captchaRef.current.reset();
          setCaptchaValue(null);
        }
      }, error => {
        setError(translate('cms.form.error'));
        captchaRef.current.reset();
        setCaptchaValue(null);
      });
    } else {
      if (!captchaValue) {
        setCaptchaError(translate('cms.form.captcha_error'));
      }
      setTimeout(() => {
        const errorElements = document.getElementsByClassName('error-InformInput');
        if (errorElements && errorElements.length > 0) {
          const element = errorElements[0];
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - 200;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 300);
    }
    setErrors(errorsAux);
  };
  const handleCaptchaChange = value => {
    setCaptchaValue(value);
    if (value) {
      setCaptchaError('');
    }
  };
  //const customSubmitText = translate('cms.form.submit-' + form_id);
  const submitText = translate('cms.form.submit');
  // customSubmitText === 'cms.form.submit-' + form_id
  // ? translate('cms.form.submit')
  //  : customSubmitText;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inForm-container sia-padding-03-right sia-padding-03-bottom"
  }, fields.map(field => /*#__PURE__*/_react.default.createElement(_InFormInput.default, {
    key: field.id,
    field: field,
    values: values,
    setValues: setValuesAux,
    errors: errors,
    setErrors: setErrors,
    translate: translate,
    fetchTerms: fetchTerms,
    lang: lang
  })), /*#__PURE__*/_react.default.createElement(_Captcha.default, {
    captchaKey: captchaKey,
    captchaRef: captchaRef,
    onChange: handleCaptchaChange,
    captchaLanguage: lang,
    error: captchaError
  }), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: submit
  }, submitText), text && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-02-top sia-text-10"
  }, text), error && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-02-top",
    style: {
      color: 'red'
    }
  }, error));
};
InForm.propTypes = {
  lang: _propTypes.default.string,
  form_id: _propTypes.default.string,
  items: _propTypes.default.object.isRequired,
  onSubmit: _propTypes.default.func.isRequired,
  translate: _propTypes.default.func.isRequired,
  defaultValues: _propTypes.default.object.isRequired,
  captchaKey: _propTypes.default.string.isRequired
};
var _default = exports.default = InForm;